/* eslint camelcase: 0 */

import * as integrationsSettings from './integration_settings/index.js';
import available from './status/available.svg';
import futureIntegration from './status/future-integration.svg';
import inProgress from './status/in-progress.svg';
import inUse from './status/in-use.svg';
import setup from './status/setup.svg';

export const integrations = integrationsSettings;

export const status = {
  Available: available,
  Setup: setup,
  'In-use': inUse,
  'In-progress': inProgress,
  'Future integration': futureIntegration,
};
